var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-content pt-4",class:{'mt-10' : _vm.$vuetify.breakpoint.xs , 'mt-n3' : _vm.$vuetify.breakpoint.sm}},[_c('notices-list',{key:_vm.report_key})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }